import { forwardRef } from 'react';
import { Select as SelectLib, SelectProps as SelectLibProps } from '@ui-kitten/components';

import { CommonFieldProps } from '../commonFieldProps';
import { InputErrors } from '../Input/InputErrors';

export type SelectProps = SelectLibProps & CommonFieldProps;

export const Select = forwardRef<SelectLib, SelectProps>(
	({ error, status, errors, ...props }, ref) => {
		return (
			<SelectLib
				status={error ? 'danger' : status}
				caption={<InputErrors errors={errors} />}
				{...props}
				ref={ref}
			/>
		);
	},
);
